if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.handleCartUpdate = this.handleCartUpdate.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
      }

      connectedCallback() {
        this.recipientFieldsLiveRegion = this.querySelector(
          '#Recipient-fields-live-region-' + this.sectionId
        );
        this.checkboxInput = this.querySelector('#Recipient-checkbox-' + this.sectionId);
        this.hiddenControlField = this.querySelector('#Recipient-control-' + this.sectionId);
        this.emailInput = this.querySelector('#Recipient-email-' + this.sectionId);
        this.nameInput = this.querySelector('#Recipient-name-' + this.sectionId);
        this.messageInput = this.querySelector('#Recipient-message-' + this.sectionId);
        this.sendonInput = this.querySelector('#Recipient-send-on-' + this.sectionId);
        this.charCountEl = this.querySelector('#Recipient-char-count-' + this.sectionId);
        this.offsetProperty = this.querySelector('#Recipient-timezone-offset-' + this.sectionId);
        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper && this.errorMessageWrapper.querySelector('ul');
        this.productForm = this.closest('form');

        if (this.checkboxInput) {
          this.checkboxInput.disabled = false;
          this.checkboxInput.addEventListener('change', this.onChange.bind(this));
        }

        if (this.hiddenControlField) {
          this.hiddenControlField.disabled = true;
        }

        if (this.offsetProperty) {
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        }

        this.bindFieldEvents(this.nameInput);
        this.bindFieldEvents(this.emailInput);
        this.bindFieldEvents(this.messageInput);
        this.bindSendOnField();

        if (this.productForm) {
          this.productForm.addEventListener('submit', this.onFormSubmit);
        }

        document.addEventListener('cart:updated', this.handleCartUpdate);
        document.addEventListener('variant:change', this.onVariantChange.bind(this));

        this.onChange();
        this.setSendOnDateLimits();
        this.updateCharCount();
        this.syncAllFloatStates();
      }

      disconnectedCallback() {
        document.removeEventListener('cart:updated', this.handleCartUpdate);

        if (this.productForm) {
          this.productForm.removeEventListener('submit', this.onFormSubmit);
        }
      }

      bindFieldEvents(field) {
        if (!field) {
          return;
        }

        field.addEventListener('input', () => {
          this.updateFloatState(field);

          if (field === this.messageInput) {
            this.updateCharCount();
          }
        });

        field.addEventListener('focus', () => {
          this.updateFloatState(field);
        });

        field.addEventListener('blur', () => {
          this.updateFloatState(field);

          if (this.checkboxInput && this.checkboxInput.checked) {
            this.validateField(field, true);
          }
        });
      }

      bindSendOnField() {
        if (!this.sendonInput) {
          return;
        }

        var field = this.sendonInput;
        var wrap = field.closest('.recipient-float-field');

        if (wrap) {
          wrap.addEventListener('click', () => {
            this.openDatePicker(field);
          });
        } else {
          field.addEventListener('click', () => {
            this.openDatePicker(field);
          });
        }

        field.addEventListener('beforeinput', function (event) {
          if (
            event.inputType === 'insertText' ||
            event.inputType === 'insertFromPaste' ||
            event.inputType === 'insertReplacementText'
          ) {
            event.preventDefault();
          }
        });

        field.addEventListener('keydown', function (event) {
          if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
            event.preventDefault();
          }
        });

        field.addEventListener('paste', function (event) {
          event.preventDefault();
        });

        field.addEventListener('drop', function (event) {
          event.preventDefault();
        });

        field.addEventListener('change', () => {
          this.updateFloatState(field);
        });

        field.addEventListener('focus', () => {
          this.updateFloatState(field);
        });

        field.addEventListener('blur', () => {
          this.updateFloatState(field);
        });
      }

      openDatePicker(field) {
        if (!field || field.disabled) {
          return;
        }

        field.focus();

        if (typeof field.showPicker === 'function') {
          try {
            field.showPicker();
          } catch (error) {
            // Browser blocked showPicker outside a direct user gesture.
          }
        }
      }

      onVariantChange(event) {
        var detail = event.detail;

        if (!detail || detail.sectionId !== this.sectionId) {
          return;
        }

        if (detail.variant && detail.variant.id) {
          this.currentProductVariantId = detail.variant.id.toString();
        }
      }

      handleCartUpdate() {
        if (!this.checkboxInput || !this.checkboxInput.checked) {
          return;
        }

        this.checkboxInput.checked = false;
        this.clearInputFields();
        this.clearAllFieldErrors();
        this.clearErrorMessage();
        this.onChange();
      }

      updateFloatState(field) {
        var floatField = field && field.closest('.recipient-float-field');

        if (!floatField) {
          return;
        }

        if (field.value && field.value.trim().length > 0) {
          floatField.classList.add('is-active');
        } else if (document.activeElement !== field) {
          floatField.classList.remove('is-active');
        }
      }

      syncAllFloatStates() {
        this.inputFields().forEach((field) => {
          this.updateFloatState(field);
        });
      }

      formatISODate(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');

        return year + '-' + month + '-' + day;
      }

      getSendOnBounds() {
        var today = new Date();
        today.setHours(0, 0, 0, 0);

        var maxDate = new Date(today);
        maxDate.setDate(maxDate.getDate() + 90);

        return {
          today: today,
          maxDate: maxDate
        };
      }

      setSendOnDateLimits() {
        if (!this.sendonInput) {
          return;
        }

        var bounds = this.getSendOnBounds();

        this.sendonInput.min = this.formatISODate(bounds.today);
        this.sendonInput.max = this.formatISODate(bounds.maxDate);
      }

      setDefaultSendOnDate() {
        if (!this.sendonInput || this.sendonInput.disabled) {
          return;
        }

        var bounds = this.getSendOnBounds();
        var today = this.formatISODate(bounds.today);

        if (!this.sendonInput.value) {
          this.sendonInput.value = today;
        }

        this.updateFloatState(this.sendonInput);
      }

      updateCharCount() {
        if (!this.messageInput || !this.charCountEl) {
          return;
        }

        var maxChars =
          parseInt(this.messageInput.getAttribute('data-max-chars'), 10) ||
          parseInt(this.charCountEl.getAttribute('data-max-chars'), 10) ||
          200;
        var currentLength = this.messageInput.value ? this.messageInput.value.length : 0;

        this.charCountEl.textContent = currentLength + '/' + maxChars;
      }

      isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }

      getFieldParts(field) {
        if (!field) {
          return {};
        }

        var fieldWrap = field.closest('.recipient-fields__field');

        return {
          field: field,
          floatField: field.closest('.recipient-float-field'),
          errorEl: fieldWrap ? fieldWrap.querySelector('.recipient-field-error') : null
        };
      }

      showFieldError(field, message) {
        var parts = this.getFieldParts(field);

        if (parts.floatField) {
          parts.floatField.classList.add('is-error');
        }

        if (parts.errorEl) {
          parts.errorEl.textContent = message;
          parts.errorEl.classList.remove('hidden');
        }

        field.setAttribute('aria-invalid', 'true');

        if (parts.errorEl) {
          field.setAttribute('aria-describedby', parts.errorEl.id);
        }
      }

      clearFieldError(field) {
        var parts = this.getFieldParts(field);

        if (parts.floatField) {
          parts.floatField.classList.remove('is-error');
        }

        if (parts.errorEl) {
          parts.errorEl.textContent = '';
          parts.errorEl.classList.add('hidden');
        }

        field.setAttribute('aria-invalid', 'false');
        field.removeAttribute('aria-describedby');
      }

      validateField(field, showError) {
        if (!field || field.disabled) {
          return true;
        }

        if (field === this.messageInput || field === this.sendonInput) {
          this.clearFieldError(field);
          return true;
        }

        var value = field.value.trim();
        var emptyMessage = field.dataset.errorEmpty || 'This field is required.';
        var invalidMessage = field.dataset.errorInvalid || 'Please enter a valid value.';

        if (field === this.nameInput) {
          if (!value) {
            if (showError) {
              this.showFieldError(field, emptyMessage);
            }
            return false;
          }
        }

        if (field === this.emailInput) {
          if (!value) {
            if (showError) {
              this.showFieldError(field, emptyMessage);
            }
            return false;
          }

          if (!this.isValidEmail(value)) {
            if (showError) {
              this.showFieldError(field, invalidMessage);
            }
            return false;
          }
        }

        this.clearFieldError(field);
        return true;
      }

      validateAllFields(showError) {
        var isValid = true;

        isValid = this.validateField(this.nameInput, showError) && isValid;
        isValid = this.validateField(this.emailInput, showError) && isValid;

        return isValid;
      }

      onFormSubmit(event) {
        if (!this.checkboxInput || !this.checkboxInput.checked) {
          return;
        }

        if (!this.validateAllFields(true)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }

      onChange() {
        if (this.checkboxInput && this.checkboxInput.checked) {
          this.classList.add('is-expanded');
          this.enableInputFields();

          if (this.recipientFieldsLiveRegion) {
            this.recipientFieldsLiveRegion.textContent = 'Gift card recipient form expanded';
          }
        } else {
          this.classList.remove('is-expanded');
          this.clearInputFields();
          this.disableInputFields();
          this.clearAllFieldErrors();
          this.clearErrorMessage();
          this.updateCharCount();
          this.syncAllFloatStates();

          if (this.recipientFieldsLiveRegion) {
            this.recipientFieldsLiveRegion.textContent = 'Gift card recipient form collapsed';
          }
        }
      }

      inputFields() {
        return [this.nameInput, this.emailInput, this.messageInput, this.sendonInput].filter(Boolean);
      }

      disableableFields() {
        var fields = this.inputFields();

        if (this.offsetProperty) {
          fields.push(this.offsetProperty);
        }

        return fields;
      }

      clearInputFields() {
        this.inputFields().forEach(function (field) {
          field.value = '';
        });
      }

      enableInputFields() {
        this.disableableFields().forEach(function (field) {
          field.disabled = false;
        });

        this.setSendOnDateLimits();
        this.setDefaultSendOnDate();
        this.syncAllFloatStates();
        this.updateCharCount();
      }

      disableInputFields() {
        this.disableableFields().forEach(function (field) {
          field.disabled = true;
        });
      }

      clearAllFieldErrors() {
        this.inputFields().forEach((field) => {
          this.clearFieldError(field);
        });
      }

      clearErrorMessage() {
        if (this.errorMessageWrapper) {
          this.errorMessageWrapper.hidden = true;
        }

        if (this.errorMessageList) {
          this.errorMessageList.innerHTML = '';
        }
      }
    }
  );
}
